<template>
    <div class="blog-item">
        <router-link :to="blogUrl" class="blog-item-cover">
            <img :src="blog.itu">
        </router-link>
        <div class="blog-item-des">
            <div class="des-bg"></div>
            <div class="des-content">
                <router-link :to="blogUrl">{{ blog.t }}</router-link>
                <p>{{ blog.s }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, ref } from 'vue';
export default {
    name: 'BlogItem',
    props: {
        blog: {
            type: Object
        },
    },
    setup(props) {
        const blog = ref(props.blog);
        const postCode = ref(blog.value.p);
        const blogUrl = computed(() => `/blog/${postCode.value}`);

        return { blogUrl }
    },
}
</script>

<style scoped>
.blog-item{
    align-items: flex-start;
    aspect-ratio: 300 / 261;
    max-height: 261px;
    min-height: 240px;
    border-radius: 20px;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.blog-item:hover {
    transform: scale(1.05);
}

.blog-item,
.des-content {
    display: flex;
}

.blog-item,
.des-content a,
.des-content p {
    overflow: hidden;
}

.blog-item-cover {
    max-height: 240px;
    min-height: 200px;
}

.blog-item-cover,
.blog-item-cover img {
    border-radius: inherit;
}

.blog-item-cover,
.blog-item-cover img,
.blog-item-des {
    width: 100%;
}

.blog-item-cover,
.des-content a {
    display: block;
}

.blog-item-cover img {
    object-fit: contain;
}

.blog-item-cover img,
.des-bg {
    height: 100%;
}

.blog-item-des {
    background-color: rgba(255, 255, 255, 0.8);
    bottom: 0;
    height: 84px;
}

.blog-item-des,
.des-content {
    position: absolute;
    right: 0;
    left: 0;
}

.des-bg {
    backdrop-filter: blur(20px);
}

.des-content {
    flex-direction: column;
    gap: 5px;
    padding: 20px 5.834%;
    top: 0;
}

.des-content a,
.des-content p {
    white-space: nowrap;
    text-overflow: ellipsis;
}

.des-content a {
    font-family: IRANYekan-Bold;
    font-size: 16px;
    color: #000000;
}

.des-content p {
    font-size: 14px;
}

@media screen and (max-width: 768px) {
    .blog-item{
        max-height: 240px;
        min-height: 210px;
    }

    .blog-item-cover {
        max-height: 200px;
        min-height: 192px;
    }

    .blog-item-des {
        height: 75px;
    }

    .des-content {
        padding-block: 17.5px;
    }

    .des-content a {
        font-size: 14px;
    }

    .des-content p {
        font-size: 12px;
    }
}

@media screen and (max-width: 360px) {
    .blog-item{
        max-height: 210px;
    }

    .blog-item-cover {
        max-height: 192px;
    }

    .blog-item-des {
        height: 67px;
    }

    .des-content {
        gap: 8px;
        padding-block: 12px;
    }
}
</style>